import { Injectable } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';

@Injectable()
export class SidebarService {
  private _collapsed = true;
  private _isDashboard = false;
  private _isEdit = false;

  constructor(private router: Router) {
    this.router.events
      .pipe(filter((event): event is NavigationEnd => event instanceof NavigationEnd))
      .subscribe((event) => {
        this._isDashboard = event.urlAfterRedirects.includes('/app/contract/');
      });
  }

  get collapsed(): boolean {
    return this._collapsed;
  }

  get isDashboard(): boolean{
    return this._isDashboard;
  }

  get isEdit(): boolean{
    return this._isEdit;
  }

  toggle() {
    this._collapsed = !this._collapsed;
  }

  open() {
    this._collapsed = false;
  }

  close() {
    this._collapsed = true;
  }

  setIsEdit(value: boolean) {
    this._isEdit = value;
  }
}